export interface BusEvent {
  type: string
  service_id?: number
  timestamp: number
  payload?: Record<string, unknown>
}

export type EventHandler = (event: BusEvent) => void

export class EventClient {
  private source: EventSource | null = null
  private readonly handlers = new Set<EventHandler>()

  constructor(
    private readonly url: string,
    private readonly sourceFactory: ((url: string) => EventSource) | null = (value) => new EventSource(value),
  ) {}

  connect() {
    if (this.source || !this.sourceFactory) return
    this.source = this.sourceFactory(this.url)
    this.source.onmessage = (msg) => this.dispatchMessage(msg)
  }

  subscribe(handler: EventHandler) {
    this.connect()
    this.handlers.add(handler)
    return () => {
      this.handlers.delete(handler)
      if (this.handlers.size === 0) {
        this.close()
      }
    }
  }

  dispatchMessage(msg: MessageEvent<string>) {
    if (!msg.data) return
    let event: BusEvent
    try {
      event = JSON.parse(msg.data) as BusEvent
    } catch {
      return
    }
    this.handlers.forEach((handler) => handler(event))
  }

  close() {
    this.source?.close()
    this.source = null
  }
}

export function createEventClient(url: string, sourceFactory?: (url: string) => EventSource) {
  return new EventClient(url, sourceFactory ?? null)
}

export const eventClient = createEventClient('/api/events')
